import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatDividerModule } from "@angular/material/divider";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyRadioModule as MatRadioModule } from "@angular/material/legacy-radio";
import { TranslateModule } from "@ngx-translate/core";
import { DialogLayoutModule } from "@obg/mat.ui.core";
import { ComponentFactoryService, CoreUiModule } from "@obg/ngx.ui.core";

import { IauiVerificationDialogContainer } from "./iaui-verification-dialog.container";
import { IauiVerificationStepContainer } from "./iaui-verification-step.container";
import { IauiVerificationComponent } from "./iaui-verification.component";

@NgModule({
	imports: [
		CoreUiModule,
		CommonModule,
		MatDividerModule,
		MatButtonModule,
		MatRadioModule,
		ReactiveFormsModule,
		DialogLayoutModule,
		TranslateModule,
	],
	exports: [IauiVerificationComponent, IauiVerificationDialogContainer, IauiVerificationStepContainer],
	declarations: [IauiVerificationComponent, IauiVerificationDialogContainer, IauiVerificationStepContainer],
})
export class IauiVerificationModule {
	constructor(resolver: ComponentFactoryResolver, componentFactoryService: ComponentFactoryService) {
		componentFactoryService.registerLazyLoadedResolver(resolver, IauiVerificationComponent);
	}
}
